import api, { apiExchange } from '../api';

export async function getAwaitedReports(cnt_id, cnt_id_push) {
  const { data } = await api.post(`${apiExchange}/report/getnewsfull`,{
    cnt_id,
    cnt_id_push,
  });
  return data;
}

export async function getAwaitedTransmissions(cnt_id, cnt_id_push) {
  const { data } = await api.post(`${apiExchange}/transmission/getnewsfull`,{
    cnt_id,
    cnt_id_push,
  });
  return data;
}

export async function getCrashedEstablishments(cnt_id) {
  const { data } = await api.post(`${apiExchange}/list/crashedEstablishments`,{
    cnt_id,
  });
  return data;
}